/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ArrowCircleRightOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12.57 15.178 15.75 12m0 0-3.18-3.178M15.75 12h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
})));
// Fill
const ArrowCircleRightFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 2.25c-1.93 0-3.81.572-5.42 1.643a9.785 9.785 0 0 0-3.59 4.376 9.699 9.699 0 0 0-.55 5.633 9.66 9.66 0 0 0 2.67 4.992 9.738 9.738 0 0 0 10.62 2.114 9.765 9.765 0 0 0 4.38-3.591A9.738 9.738 0 0 0 18.89 5.11 9.785 9.785 0 0 0 12 2.25zm4.44 10.04a.778.778 0 0 1-.16.244l-3.18 3.179c-.07.069-.15.125-.24.162s-.19.055-.29.053c-.1.002-.2-.016-.29-.053s-.17-.092-.24-.162a.755.755 0 0 1-.22-.53c0-.2.08-.39.22-.53l1.9-1.903H8.25a.751.751 0 0 1 0-1.5h5.69l-1.9-1.903a.776.776 0 0 1-.2-.522.805.805 0 0 1 .22-.512.755.755 0 0 1 1.04-.025l3.18 3.178c.07.07.12.152.16.243.08.187.08.395 0 .582z"
})));
// DuoTone
const ArrowCircleRightDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12.13 14.736c-.24.244-.24.64 0 .884s.64.244.88 0l-.88-.884zM15.75 12l.44.442a.615.615 0 0 0 0-.884l-.44.442zm-2.74-3.62c-.24-.244-.64-.244-.88 0s-.24.64 0 .884l.88-.884zm-4.76 2.995c-.35 0-.63.28-.63.625s.28.625.63.625v-1.25zM20.38 12A8.377 8.377 0 0 1 12 20.375v1.25c5.32 0 9.62-4.309 9.62-9.625h-1.24zM12 20.375c-4.63 0-8.38-3.75-8.38-8.375H2.38c0 5.316 4.3 9.625 9.62 9.625v-1.25zM3.62 12A8.377 8.377 0 0 1 12 3.625v-1.25c-5.32 0-9.62 4.309-9.62 9.625h1.24zM12 3.625c4.63 0 8.38 3.75 8.38 8.375h1.24c0-5.316-4.3-9.625-9.62-9.625v1.25zm1.01 11.995 3.18-3.178-.88-.884-3.18 3.178.88.884zm3.18-4.062L13.01 8.38l-.88.884 3.18 3.178.88-.884zm-7.94 1.067h7.5v-1.25h-7.5v1.25z"
})));
/**
  Icon ArrowCircleRightIcon in arrows group
*/
export const ArrowCircleRightIcon = createIcon('ArrowCircleRightIcon', 'arrow-circle-right', 'arrows', ArrowCircleRightOutline, ArrowCircleRightFill, ArrowCircleRightDuotone, "0 0 24 24");